import moment from 'moment';
import _ from 'underscore';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { storeUtils } from './util';
import { userStore } from './user';
import { subdivisionStore } from './subdivision';
import { formConversion } from '../util/formConversion';
import { formValidation } from '../util/formValidation';
import { ServerAPI } from '../actions/serverAPI';
import { formbScrubber } from '../util/formbScrubber';

const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var _submitting = false;
var _modifyingExistingForm = false;
var _inEditMode = false;

var _canSubmit = false;
var _isDirty = false;
var _showDefaultTracks = false;
var _defaultTrackNames = [];
var _schematicTrackNames = [];

var _validity = { isValid: false, errors: [], warnings: [] };
var _touchedFields = [];
var _showAllErrors = false; //used for when submit is pressed

var _readOnly = false;
var _partialReadOnly = false;
var _hideActionButtons = false;
var _isWeatherRequest = false;

var _schematicLoaded = false;

var _SubData;
let _subLocations = [];
let _filteredSubLocations = [];
let _fromLocationSuggestion = "";
let _showFormCFromLocations = false;
let _showFormTCMFromLocations = false;
let _toLocationSuggestion = "";
let _showFormCToLocations = false;
let _showFormTCMToLocations = false;
let _subLocationsLoading = false;
let _formCSubs = [];
let _showSubDrownDown = false;
let _disableFormCMileposts = false;
let _disableFormCLocations = false;
let _disableFormCSubSelection = false;
let _disableFormCEntireSub = false;
let _disableFormCAllSubs = false;
let _formCMpTitle = "";
let _formCLocTitle = "";
let _formCSubDropDownTitle = "";
let _formCEntireSubTitle = "";
let _formCEntireSubChecked = false;
let _formPatterns = [];
let _dispatcherCompactionCode = false; //This indicates if the user is a dispatcher and the compaction reason code has been selected
let _fieldUserCompactionCode = false; //This indicates if the user is a field user and the compaction reason code has been selected
let _validatingMP = false;

var CHANGE_EVENT = "change";
//initial state
var _formInitial = {
  //note, never assign this directly to _form, javascript uses reference when assigning objects. use  = formConversion.clone(_formInitial); to clone it
  id: "", //<-the grit id for updates and such
  workEndMp: "",
  workEndMpSuffix: "",
  workStartMp: "",
  workStartMpSuffix: "",
  subdivision: "",
  authInitials: "",
  commentsBlob: "",
  supervisorName: "",
  rejectionReason: "",
  type: "A", //this needs to be set to match whatever the tab is set to load first!!!!
  status: "request",
  phoneNumber: "",
  dispatcherId: "",
  isCommentOpened: false,

  //This field is only used to keep track of the dsid to which a request is transferred,
  // it is sent to the server as it's own entity
  transferredDsId: "",

  //form B fields
  foremanId: "",
  foremanName: "",
  gang: "",
  impedesTraffic: "",
  reason: "",
  reasonCode: "",
  reasonDescription: "",
  radioChannel: "",
  timezone: "",
  workEndDate: "",
  workEndTime: "",
  workEndDay: "",
  workStartDate: "",
  workStartTime: "",
  workStartDay: "",

  shortFlagOneMp: "",
  shortFlagOneMpSuffix: "",
  shortFlagTwoMp: "",
  shortFlagTwoMpSuffix: "",
  shortFlagsNotDisplayed: "",
  dispatchers: [],
  borderingFlags: [
    //	                  {
    //	                	'mp':'',
    //	                	'mpSuffix':'',
    //	                	"subdivision":'',
    //	                  }
  ],
  comments: [
    //				{"comment":"",
    //				"lineNumber":"",}
  ],
  trackGuids: [
    //{"endMp":"",
    //"guid":"",
    //"mpSuffix":"",
    //"startMp":"",
    //"subdivision":"",
    //"trackName":""}
  ],
  excludedGuids: [],
  //form A fields
  tracks: [],
  passengerSpeed: "",
  freightSpeed: "",
  effectiveDate: "",
  expectedExpireDate: "",
  effectiveTime: "",
  expectedExpireTime: "",
  effectiveTimezone: "",
  authorizedBy: "",
  sloDtComment: "",
  appliesToLimitedNumberOfTrains: null,
  outForExtendedTime: null,
  tmdsTagsPlaced: null,

  //form C fields
  fromLocation: "",
  toLocation: "",
  subdivisions: [],
  formCDTChangeComment: "",
  estimatedRemovalDate: "",

  //form TCM fields
  formTCMDTChangeComment: "",
  printIndicator: "N",
  permanentIndicator: "N",
  sendToTss: null,
};
var _form = formConversion.clone(_formInitial);
var _activeForm = null; // a temp variable to hold the active restriction for a request to modify so that values can be compared
//var _reasonCodes = [];
var _aReasons = [];
var _bReasons = [];
var _aRejectReasons = [];
var _bRejectReasons = [];
var _userEnteredMps = false; //variable to determine if the user entered the MPs
var _unmodifiedRequest = null; //a temp variable to hold the unedited request in case the user cancels their edit
let _hideForm = false;

function validateForm() {
  fetchFormBThreshold();
  _validity = formValidation.checkFormValidity(
    _form,
    userStore.getSelectedRole(),
    userStore.getLata()
  );
  _form = formbScrubber.scrub(_form);

  if (_validity.isValid) {
    _canSubmit = true;
  } else {
    _canSubmit = false;
  }
}

function fetchFormBThreshold() {
  if (sessionStorage.getItem("formBRequestThreshold")) {
    return;
  } else {
    console.log("set formB threshold")
    $.ajax({
      url: storeUtils.URL_ROOT + "form/formBRequestThreshold",
      type: "GET",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      success: function (data) {
        console.log("Setting default formB threshold from configuration");
        sessionStorage.setItem("formBRequestThreshold", data);
      },
      error: function () {
        console.error("Error fetching formB threshold");
        sessionStorage.setItem("formBRequestThreshold", 0);
      },
    })
  }
}
function resetForm() {
  _submitting = false;
  _modifyingExistingForm = false;
  _hideActionButtons = false;
  _isWeatherRequest = false;
  _isDirty = false;
  _showAllErrors = false;
  _touchedFields = [];
  _readOnly = false;
  _partialReadOnly = false;
  _userEnteredMps = false;
  _schematicTrackNames = [];
  _disableFormCMileposts = false;
  _disableFormCLocations = false;
  _disableFormCSubSelection = false;
  _disableFormCEntireSub = false;
  _disableFormCAllSubs = false;
  _formCEntireSubChecked = false;
  _hideForm = false;
  _inEditMode = false;
  _unmodifiedRequest = null;
  //update the form to the submitted state and trigger a change event.
  _form = formConversion.clone(_formInitial);
  _activeForm = null;
}

function resetFormWithErrorDisplay() {
  _modifyingExistingForm = false;
  _isDirty = false;
  _showAllErrors = false;
  _touchedFields = [];
  _readOnly = false;
  _partialReadOnly = false;
  _userEnteredMps = false;
  _schematicTrackNames = [];
  _hideForm = false;
  _inEditMode = false;
  _unmodifiedRequest = null;
  //update the form to the submitted state and trigger a change event.
  _form = formConversion.clone(_formInitial);
  _activeForm = null;
}

function changeForm(type) {
  resetForm();
  _form.type = type;
  _formInitial.type = type;
  console.log("form type set to: ", type);
}

function getAvailableTracks() {
  var trackList = _schematicTrackNames;

  if (_showDefaultTracks) {
    trackList = _.uniq(
      _.union(_schematicTrackNames, _defaultTrackNames),
      false,
      function (e) {
        return e.toLowerCase();
      }
    );
  }

  return trackList.map(function (tr) {
    return { name: tr, checked: false };
  });
}

var dispatchToken = dispatcher.register(function (action) {
  //this action comes from the dispatcher
  switch (action.type) {
    case ActionTypes.TOGGLE_HIDE_ACTION_BUTTONS:
      _hideActionButtons = action.hideButtons;
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.TRACK_LIST_UPDATED:
      //todo: move this to another store
      //availableTrackList = action.tracks.map(function(tr){return {name: tr, checked:false}});
      _schematicTrackNames = action.tracks;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TAB_CHANGED:
      //If they change the tab turn off edit mode
      _inEditMode = false;
      if (action.tabChanged === "form") {
        changeForm(Constants.Tabs[action.tabIndex]);
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.REASON_CODES_LOADED:
      console.log("Reason codes loaded", action);
      if (action.formType === Constants.RestrictionTypes.A) {
        _aReasons = action.codes;
      } else if (action.formType === Constants.RestrictionTypes.B) {
        _bReasons = action.codes;
      } else if (action.formType === Constants.RejectReasonType.FORMA_REJECT) {
        _aRejectReasons = action.codes;
      } else if (action.formType === Constants.RejectReasonType.FORMB_REJECT) {
        _bRejectReasons = action.codes;
      }
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.UPDATE_SCHEMATIC_FROM_TEXT:
      if (typeof action.restriction.workEndMp === "string") {
        action.restriction.workEndMp = action.restriction.workEndMp.trim();
      }
      if (typeof action.restriction.workStartMp === "string") {
        action.restriction.workStartMp = action.restriction.workStartMp.trim();
      }
      break;

    case ActionTypes.FORM_FIELD_BLURRED:
      if (typeof action.restriction[action.fieldId] === "string") {
        action.restriction[action.fieldId] =
          action.restriction[action.fieldId].trim();
      }
      if (action.restriction[action.fieldId] !== _form[action.fieldId]) {
        _isDirty = true;
      }

      if (action.fieldId === "fromLocation") {
        if (_fromLocationSuggestion !== "") {
          action.restriction.fromLocation = _fromLocationSuggestion;
          _fromLocationSuggestion = "";
        }
        _filteredSubLocations = _subLocations;
      }

      if (action.fieldId === "toLocation") {
        if (_toLocationSuggestion !== "") {
          action.restriction.toLocation = _toLocationSuggestion;
          _toLocationSuggestion = "";
        }
        _filteredSubLocations = _subLocations;
      }

      _disableFormCLocations = false;
      _disableFormCMileposts = false;
      _disableFormCSubSelection = false;

      if (
        action.restriction.subdivision !== "ALL" &&
        action.restriction.subdivision !== "MULTI" &&
        !_formCEntireSubChecked &&
        action.restriction.subdivisions &&
        action.restriction.subdivisions.length <= 1
      ) {
        if (
          action.restriction.fromLocation !== "" ||
          action.restriction.toLocation !== ""
        ) {
          _disableFormCMileposts = true;
          _disableFormCSubSelection = true;
          _formCMpTitle = "Clear entered locations to enter a milepost";
          _formCSubDropDownTitle =
            "Clear Location/MP range to select multiple subdivisions";
        }

        if (
          action.restriction.workStartMp !== "" ||
          action.restriction.workStartMpSuffix !== "" ||
          action.restriction.workEndMp !== "" ||
          action.restriction.workEndMpSuffix !== ""
        ) {
          _disableFormCLocations = true;
          _disableFormCSubSelection = true;
          _formCLocTitle = "Clear entered mileposts to enter a location";
          _formCSubDropDownTitle =
            "Clear Location/MP range to select multiple subdivisions";
        }
      } else if (action.restriction.type === "TCM") {
        if (
          action.restriction.fromLocation !== "" ||
          action.restriction.toLocation !== ""
        ) {
          _disableFormCMileposts = true;
          _formCMpTitle = "Clear entered locations to enter a milepost";
        }

        if (
          action.restriction.workStartMp !== "" ||
          action.restriction.workStartMpSuffix !== "" ||
          action.restriction.workEndMp !== "" ||
          action.restriction.workEndMpSuffix !== ""
        ) {
          _disableFormCLocations = true;
          _formCLocTitle = "Clear entered mileposts to enter a location";
        }
      } else {
        _disableFormCLocations = true;
        _disableFormCMileposts = true;
        // _disableFormCSubSelection = true;
      }

      _form = action.restriction;

      // Restricting fromLocation and toLocation as those are not mandatory fields
      if (
        action.fieldId !== "fromLocation" &&
        action.fieldId !== "toLocation"
      ) {
        _touchedFields = _.union(_touchedFields, [action.fieldId]);
      }
      validateForm();
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.FORM_FIELD_CHANGED:
      let updateForm = true;
      if (action.restriction[action.fieldId] !== _form[action.fieldId] && !action.skipDirty) {
        //compare against the unchanged form to see if something changed on blur
        _isDirty = true;
      }
      if (
        action.fieldId === "fromLocation" ||
        action.fieldId === "toLocation"
      ) {
        let fromCheck = action.fieldId === "fromLocation";
        let filterString = action.restriction[action.fieldId]
          .toString()
          .toUpperCase();
        let tmpList = _filteredSubLocations.slice();

        _filteredSubLocations = _subLocations.filter(function (item) {
          if (
            item.locationId.toString().toUpperCase().indexOf(filterString) === 0
          ) {
            return true;
          }
        });

        if (_filteredSubLocations.length > 0) {
          if (fromCheck) {
            _fromLocationSuggestion =
              _filteredSubLocations[0].locationId.trim();
          } else {
            _toLocationSuggestion = _filteredSubLocations[0].locationId.trim();
          }
        } else {
          _filteredSubLocations = tmpList;
          updateForm = false;
        }

        if (filterString === undefined || filterString === "") {
          _fromLocationSuggestion = "";
          _toLocationSuggestion = "";
        }
      }

      if (updateForm) {
        _form = action.restriction;
      }

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.WORK_START_DATE_CHANGED:
    case ActionTypes.WORK_END_DATE_CHANGED:
    case ActionTypes.EXPIRE_DATE_CHANGED:
    case ActionTypes.EFFECTIVE_DATE_CHANGED:
    case ActionTypes.ESTIMATED_REMOVAL_DATE_CHANGED:
      if (action.restriction[action.fieldId] !== action.date) {
        _isDirty = true;
      }
      action.restriction[action.fieldId] = action.date;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TRACK_SELECTION_CHANGED:
      if (action.checked) {
        _form.tracks.push({ name: action.trackId, checked: true });
      } else {
        _form.tracks = _.filter(_form.tracks, function (tr) {
          return tr.name !== action.trackId;
        });
      }
      validateForm();
      _isDirty = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SELECT_CHANGED:
      var valueAsInt = parseInt(action.value);
      if (valueAsInt) {
        _form[action.field] = valueAsInt;
      } else {
        _form[action.field] = action.value;
      }
      validateForm();
      if (action.field !== "transferredDsId") {
        _isDirty = true;
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.REASON_CHANGED:
      let reasonAsInt = parseInt(action.reason);
      _form["reason"] = reasonAsInt;
      _form["reasonDescription"] = action.text;
      validateForm();
      _isDirty = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.NO_FLAGS_CHANGED:
      if (action.value) {
        _form.shortFlagsNotDisplayed = true;
        _form.shortFlagOneMp = "";
        _form.shortFlagOneMpSuffix = "";
        _form.shortFlagTwoMp = "";
        _form.shortFlagTwoMpSuffix = "";
        _form.borderingFlags = [];
      } else _form.shortFlagsNotDisplayed = false;
      validateForm();
      _isDirty = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED:
      _showDefaultTracks = action.value;

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.RETRIEVED_DEFAULT_TRACKS:
      _defaultTrackNames = action.tracks;

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUPERVISOR_AUTH_SET:
      _form.supervisorName = action.value;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.CONFIRM_SET:
      _form.tmdsTagsPlaced = action.value;
      //_form.status = 'verbal';
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SLODT_SET:
      _form.sloDtComment = action.value;
      //_form.status = 'verbal';
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.FORMCDT_SET:
      _form.formCDTChangeComment = action.value;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.FORMTCMDT_SET:
      _form.formTCMDTChangeComment = action.value;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.REQUEST_RADIO_CHANGED:
      console.log("REQUEST_RADIO_CHANGED", action);
      _form[action.id] = action.value === "true"; //store it as a boolean since action.value is a string
      //check if the value of the radio button is null
      if (action.value == null) {
        _form[action.id] = null;
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TCM_COND_PERM_CHANGED:
      if (action.value) {
        _form.permanentIndicator = "Y";
        //Set the estimatedRemovalDate to 60 days form today
        _form.estimatedRemovalDate = moment().add(60, "d").format("MMDDYY");
      } else {
        _form.permanentIndicator = "N";
        _form.estimatedRemovalDate = "";
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TCM_PRINT_CHANGE:
      if (action.value) {
        _form.printIndicator = "Y";
      } else {
        _form.printIndicator = "N";
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.OPEN_FORM_B_REQUEST:
      resetForm();

      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _readOnly = false;
        _partialReadOnly = false;
        if (
          userStore.getSelectedRole().indexOf(Constants.Roles.READ_ONLY) > -1
        ) {
          _readOnly = true;
          _partialReadOnly = true;
        }
        _modifyingExistingForm = true;
        _showAllErrors = true;
        console.log(ActionTypes.OPEN_FORM_B_REQUEST, _form);
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.OPEN_FORM_B_RESTRICTION:
      resetForm();
      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _modifyingExistingForm = true;
        _readOnly = true;
        _partialReadOnly = true;
        console.log(ActionTypes.OPEN_FORM_B_RESTRICTION, _form);
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.OPEN_FORM_C_RESTRICTION:
      resetForm();
      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _modifyingExistingForm = true;
        _readOnly = true;
        _partialReadOnly = true;
        if (
          userStore.getSelectedRole().indexOf(Constants.Roles.DISPATCHER) > -1
        ) {
          _readOnly = false;
          _partialReadOnly = false;
        } else if (
          userStore.getUserRole().indexOf(Constants.Roles.FIELD_SLODT) > -1
        ) {
          _readOnly = false;
          _partialReadOnly = true;
        }

        // Disabling Correct form C fields on Modify action

        if (_form.workStartMp || _form.workEndMp) {
          _disableFormCLocations = true;
        }

        if (_form.fromLocation || _form.toLocation) {
          _disableFormCMileposts = true;
        }
        if (_form.subdivisions.length == 1) {
          _disableFormCSubSelection = true;
        }
        if (_form.subdivision === "MULTI") {
          _disableFormCMileposts = true;
          _disableFormCLocations = true;
          _disableFormCEntireSub = true;
          _disableFormCAllSubs = true; //Can't change a MULTI to an all
        } else if (_form.subdivision === "ALL") {
          _disableFormCMileposts = true;
          _disableFormCLocations = true;
          _disableFormCEntireSub = true;
          _disableFormCSubSelection = true; //Can't add subs to an ALL when opening
          _formCSubDropDownTitle =
            "ALL subdivisions restrictions can't be modified with additional subdivisions";
          _disableFormCAllSubs = true; //Can't change an ALL when opening
        } else {
          _disableFormCAllSubs = true; //Can't change a single to an ALL
        }

        console.log(ActionTypes.OPEN_FORM_C_RESTRICTION, _form);
        _events.trigger(CHANGE_EVENT);
      }
      break;
    case ActionTypes.OPEN_TCM_RESTRICTION:
      resetForm();
      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _modifyingExistingForm = true;
        _readOnly = true;
        _partialReadOnly = true;
        if (
          userStore.getSelectedRole().indexOf(Constants.Roles.DISPATCHER) > -1
        ) {
          _readOnly = false;
          _partialReadOnly = false;
        } else if (
          userStore.getUserRole().indexOf(Constants.Roles.FIELD_SLODT) > -1
        ) {
          _readOnly = false;
          _partialReadOnly = true;
        }

        // Disabling Correct form C fields on Modify action

        if (_form.workStartMp || _form.workEndMp) {
          _disableFormCLocations = true;
          _disableFormCSubSelection = true;
        }

        if (_form.fromLocation || _form.toLocation) {
          _disableFormCMileposts = true;
          _disableFormCSubSelection = true;
        }
        console.log(ActionTypes.OPEN_TCM_RESTRICTION, _form);
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.OPEN_FORM_A_RESTRICTION:
      resetForm();

      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _form.prevFreightSpd = _form.freightSpeed;
        _form.comments = (_form.comments || []).filter(
          (c) => c.comment !== window.gritConfig.keyTrainComment
        );
        _readOnly = true;
        _partialReadOnly = true;
        _modifyingExistingForm = true;
        if (
          userStore.getSelectedRole().indexOf(Constants.Roles.DISPATCHER) > -1
        ) {
          _readOnly = false;
          _partialReadOnly = false;
        } else if (
          userStore.getUserRole().indexOf(Constants.Roles.FIELD_SLODT) > -1
        ) {
          _readOnly = false;
          _partialReadOnly = true;
        }
        console.log(ActionTypes.OPEN_FORM_A_RESTRICTION, _form);
        _events.trigger(CHANGE_EVENT);
      }
      break;
    case ActionTypes.OPEN_FORM_A_REQUEST:
      resetForm();

      //Check that the form was loaded correctly before trying to open it
      if (action.form) {
        _form = action.form;
        _form.prevFreightSpd = _form.freightSpeed;
        _form.comments = (_form.comments || []).filter(
          (c) => c.comment !== window.gritConfig.keyTrainComment
        );
        _activeForm = action.activeForm; //This will only be populated on a request to modify
        _modifyingExistingForm = true;
        _readOnly = false;
        _partialReadOnly = false;
        //Dispatchers and higher should be read only to require the button press
        if (
          userStore.getSelectedRole().indexOf(Constants.Roles.DISPATCHER) >
          -1 ||
          (_form.status === Constants.RestrictionStatuses.REQUESTED &&
            _form.controlNumber !== 0)
        ) {
          _readOnly = true;
          _partialReadOnly = true;
        }

        if (window.gritConfig.weatherWarningKey &&
          String(_form.reasonDescription).startsWith(window.gritConfig.weatherWarningKey)) {
          _isWeatherRequest = true;
          _readOnly = true;
          _partialReadOnly = true;
          _events.trigger(CHANGE_EVENT);
        }
      }
      break;

    case ActionTypes.TOGGLE_MODIFY_REQUEST_MODE:
      _inEditMode = action.value;
      if (_inEditMode) {
        //Save the original restriction
        _unmodifiedRequest = _form;
        _activeForm = _form;
        _readOnly = false;
        _partialReadOnly = false;
      } else {
        //Restore the original restriction
        _form = _unmodifiedRequest;
        _activeForm = undefined;
        _readOnly = true;
        _partialReadOnly = true;
        //Clear the is dirty flag for the form
        _isDirty = false;
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.VALIDATE_FORM_B_RESTRICTION:
      validateForm();
      if (_validity.isValid) {
        console.log("form valid on submit");
      } else {
        _showAllErrors = true;
        console.log("form invalid on submit");
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.RESET_FORM_B_RESTRICTION:
      resetForm();
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.POLL_SUCCESSFUL:
      _hideForm = false;
      resetForm();
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.REMOVE_POLL_ID:
      _hideForm = false;
      resetFormWithErrorDisplay();
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUBMIT_TO_SERVER_SUCCESSFUL:
      _form.syncId = action.request.syncId;
      break;

    case ActionTypes.SUBMIT_TO_SERVER_FAILED:
    case ActionTypes.SUBMIT_TO_SERVER_404_500:
      //for some reason the save failed on the server, so re-render the form as entered, and display an error
      _submitting = false;
      _showAllErrors = true;
      _hideForm = false;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.MF_ERROR_RETURNED:
      //grab the ids off the record so when the user re-submits we can update the existing record
      _hideForm = false;
      _form.syncId = action.form.syncId;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.PERMISSION_EXCEPTION:
      //for some reason the save failed on the server, so re-render the form as entered, and display an error
      _submitting = false;
      _showAllErrors = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.COMMENT_MODAL_OPENED:
      _form.isCommentOpened = action.isCommentOpened;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.COMMENT_MODAL_CLOSED:
      var coms = [];

      //	/*there are two kinds of lines, those from a user pressing enter, and those that are wrapped because they
      //	* are longer than 80 chars in the textarea. This methods converts wrapped lines to user entered
      //	* lines so that when we store to the DB the line breaks are persisted correctly, since wrapped line
      //	* linebreaks can't be easily detected*/

      //all the lines separated by the user pressing enter
      var userEnteredLines = action.comments.split("\n");

      var l = userEnteredLines.length;

      for (var i = l - 1; i >= 0; i--) {
        //go through each line of user entered text

        //console.log(i,l, userEnteredLines[i]);
        if (
          userEnteredLines[i].length >
          Constants.MaxValues.MAX_COMMENT_LINE_LENGTH
        ) {
          //break this line into multiple lines at 80 char chunks
          var chunkedLines = chunkString(
            userEnteredLines[i],
            Constants.MaxValues.MAX_COMMENT_LINE_LENGTH
          ); //chunk the lines into 80 char segments
          userEnteredLines.splice(i, 1, chunkedLines);
        }
      }
      //flatten the array
      coms = _.flatten(userEnteredLines, true);

      coms = coms.filter(function (com) {
        return com !== "";
      }); //get all the non blank comments

      var comments = coms.map(function (com, i) {
        return { comment: com, lineNumber: i + 1 };
      }); //build into comment objects
      if (!formConversion.areArraysEqual(comments, _form.comments)) {
        _isDirty = true;
        _form.comments = comments;
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.BORDERING_FLAG_MODAL_CLOSED:
      var flags = action.flags.map(function (flag) {
        return {
          mp: flag.mp,
          mpSuffix: flag.mpSuffix,
          subdivision: flag.subdivision,
        };
      });
      if (!formConversion.areArraysEqual(flags, _form.borderingFlags)) {
        _isDirty = true;
        _form.borderingFlags = flags;
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.USER_CHANGED:
      dispatcher.waitFor([subdivisionStore.dispatchToken]);
      resetForm();
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUBDIVISION_CHANGED:
      _form.subdivision = action.selectedSub;
      _formInitial.subdivision = action.selectedSub;
      _formInitial.subdivisions = [];
      _formInitial.subdivisions.push(action.selectedSub);
      _filteredSubLocations = []; //Clear the location list when the sub is changed
      _formCEntireSubChecked = false; //Uncheck entire sub if the sub is changed
      resetForm();
      _schematicLoaded = false; //Reset this on a sub change since the schematic has to be reloaded
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUBDIVISION_DETAILS_LOADED:
      _form.timezone = action.details.defaultTimezone;
      _formInitial.timezone = action.details.defaultTimezone;

      _form.timeTableDirection = action.details.defaultDirection;
      _formInitial.timeTableDirection = action.details.defaultDirection;

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SCHEMATIC_SUB_FAILED_LOAD:
      _schematicLoaded = false; //Set readonly if sub fails to load

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SCHEMATIC_SUB_LOADED:
      _schematicLoaded = true;

      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.REJECTED_FORM_B_RESTRICTION:
    case ActionTypes.DELETE_FORM_B_REQUEST:
    case ActionTypes.VOID_FORM_B_RESTRICTION:
      if (action.clearForm) {
        resetForm();
        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.SCHEMATIC_CLICKED:
      if (_form.type === "A" || _form.type === "B") {
        console.log(ActionTypes.SCHEMATIC_CLICKED, action);

        if (action.field) {
          //set the field they picked
          _form[action.field] = action.mp;
          _form[action.field + "Suffix"] = action.sfx;
          _isDirty = true;
        } else if (!_form.workStartMp) {
          _form.workStartMp = action.mp;
          _form.workStartMpSuffix = action.sfx;
          _isDirty = true;
        } else if (!_form.workEndMp) {
          _form.workEndMp = action.mp;
          _form.workEndMpSuffix = action.sfx;
          _isDirty = true;
        }
        validateForm();

        if (_form.workStartMp && _form.workEndMp) {
          setTimeout(function () {
            dispatcher.dispatch({
              type: ActionTypes.SERVER_CALCULATING_GUIDS,
            });
          }, 1);

          var calc = ServerAPI.calculateTracks(_form);

          calc
            .done(function success(data) {
              if (data.success) {
                if (!data.data.showDefaultTracks) {
                  console.log("select all track", _isWeatherRequest);
                  dispatcher.dispatch({
                    type: ActionTypes.SERVER_CALCULATED_GUIDS,
                    data: data.data,
                    selectAllTracks: _isWeatherRequest,
                  });
                } else {
                  var msg = "Contact the appropriate dispatcher.";
                  if (
                    userStore
                      .getSelectedRole()
                      .indexOf(Constants.Roles.DISPATCHER) > -1
                  ) {
                    msg = "Contact the system ACD.";
                  }
                  dispatcher.dispatch({
                    type: ActionTypes.SERVER_GUID_ERROR,
                    message: "Mps not connected. Override Required. " + msg,
                  });
                }
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.SERVER_GUID_ERROR,
                  message: data.errors[0].message,
                });
              }
            })
            .fail(function (data) {
              //throw some error
              console.log(data);
            });
        }

        _events.trigger(CHANGE_EVENT);
      }
      break;

    case ActionTypes.SCHEMATIC_UPDATE_COMPLETE:
      //clear all track names if marked
      if (action.clearSelectedTracks) {
        _form.tracks = [];
      } else {
        //set the guids
        _form.trackGuids = action.guids.map(function (g) {
          return g.attributes;
        });
        _form.excludedGuids = action.excludedGuids.map(function (g) {
          return g.attributes;
        });

        //update the available tracks. If we are modifying an existing then show any bad track names unless the user changes something on the form
        if (action.tracks && action.tracks.length > -1) {
          if (!_modifyingExistingForm || (_modifyingExistingForm && _isDirty)) {
            _form.tracks = _form.tracks.filter(function (t) {
              return action.tracks.indexOf(t.name) > -1;
            }); //Filter out tracks that are not on the current selection
          }
        }
        validateForm();
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TERRITORY_CHANGED:
      if (!action.autoSelected) resetForm();
      var dsid =
        action.selectedTerritory === 0 ? " " : action.selectedTerritory;
      _formInitial.dispatcherId = dsid;
      _form.dispatcherId = dsid;
      break;

    case ActionTypes.SUBDIVISION_LOCATIONS_LOADING:
      _subLocationsLoading = true;
      _subLocations = [];
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.SUBDIVISION_LOCATIONS_LOADED:
      _subLocationsLoading = false;
      _subLocations = action.data;
      _filteredSubLocations = _subLocations;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.PATTERN_LIST_LOADED:
      _formPatterns = action.data;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TOGGLE_SHOW_FORM_C_FROM_LOCATIONS:
      _showFormCFromLocations = action.flag;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TOGGLE_SHOW_FORM_TCM_FROM_LOCATIONS:
      _showFormTCMFromLocations = action.flag;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TOGGLE_SHOW_FORM_C_TO_LOCATIONS:
      _showFormCToLocations = action.flag;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TOGGLE_SHOW_FORM_TCM_TO_LOCATIONS:
      _showFormTCMToLocations = action.flag;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.FORM_C_SUBDIVISION_SELECTED:
      var index = _form.subdivisions.indexOf(action.sub);
      _disableFormCSubSelection = false;
      _filteredSubLocations = []; //Clear out the subdivisions when sub selection changes
      let allAdded = false;
      if (index > -1) {
        _form.subdivisions.splice(index, 1);
        if (_form.subdivisions.length === 1) {
          //If just one sub left, set the subdivision of the form to that
          _form.subdivision = _form.subdivisions[0];
        }
      } else {
        if (action.sub === "ALL") {
          //If they have selected ALL clear other subs from list
          _form.subdivisions = [];
          _form.subdivision = action.sub;
          allAdded = true;
          _disableFormCSubSelection = true;
          _formCMpTitle =
            "MP values can't be entered for an All Subs restriction";
          _formCLocTitle =
            "Locations values can't be entered for an All Subs restriction";
          _formCEntireSubTitle =
            "Entire Sub can't be selected for an ALL Subs restriction";
          _formCSubDropDownTitle =
            "Uncheck 'SELECT ALL SUBs' to select multiple subdivisions";
        }
        _form.subdivisions.push(action.sub);
      }
      if (_form.subdivisions.length > 1 || allAdded) {
        if (!allAdded) {
          _formCMpTitle =
            "MP values can't be entered for a MULTI sub restriction";
          _formCLocTitle =
            "Locations values can't be entered for a MULTI sub restriction";
          _formCEntireSubTitle =
            "Entire Sub can't be selected for a MULTI sub restriction";
          _form.subdivision = "MULTI";
        }
        _disableFormCLocations = true;
        _form.fromLocation = "";
        _form.toLocation = "";
        _showFormCFromLocations = false; //Close the location drop downs if ALL subs is selected
        _showFormCToLocations = false;
        _disableFormCMileposts = true;
        _form.workStartMp = "";
        _form.workStartMpSuffix = "";
        _form.workEndMp = "";
        _form.workEndMpSuffix = "";
        _disableFormCEntireSub = true;
      } else {
        _formCMpTitle = "";
        _formCLocTitle = "";
        _formCEntireSubTitle = "";
        _formCSubDropDownTitle = "";
        _disableFormCLocations = false;
        _disableFormCMileposts = false;
        _disableFormCEntireSub = false;
      }

      if (_form.subdivisions.length === 0) {
        _form.subdivision = _formInitial.subdivision;
        _form.subdivisions.push(_formInitial.subdivision);
      }
      //Removing Mile Post from touched fields
      _touchedFields = _.without(_touchedFields, "workStartMp");
      _touchedFields = _.without(_touchedFields, "workEndMp");
      validateForm();
      _isDirty = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.FORM_C_DIVISION_SELECTED:
      console.log(action.division);
      if (action.division.subdivisions.length === 1) {
        _form.subdivision = action.division.subdivisions[0];
      } else {
        _form.subdivision = "MULTI";
        _form.subdivisions = [];
        _form.subdivisions = _form.subdivisions.concat(
          action.division.subdivisions
        );
        _formCMpTitle =
          "MP values can't be entered for a MULTI sub restriction";
        _formCLocTitle =
          "Locations values can't be entered for a MULTI sub restriction";
        _formCEntireSubTitle =
          "Entire Sub can't be selected for a MULTI sub restriction";
        _disableFormCLocations = true;
        _form.fromLocation = "";
        _form.toLocation = "";
        _showFormCFromLocations = false;
        _showFormCToLocations = false;
        _disableFormCMileposts = true;
        _form.workStartMp = "";
        _form.workStartMpSuffix = "";
        _form.workEndMp = "";
        _form.workEndMpSuffix = "";
        _disableFormCEntireSub = true;
        _showSubDrownDown = false; //Hide the drop down after selecting a division
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.FORM_C_LOCATION_SELECTED:
      _disableFormCSubSelection = true;
      _disableFormCMileposts = true;
      _isDirty = true;
      //Clear the location suggestions
      _fromLocationSuggestion = "";
      _toLocationSuggestion = "";
      //Reset the locaton list
      _filteredSubLocations = _subLocations;
      if (action.locationType === "from") {
        _form.fromLocation = action.location;
      } else {
        _form.toLocation = action.location;
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TOGGLE_SHOW_SUB_DROPDOWN:
      _showSubDrownDown = action.show;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.CHANGED_SELECT_ENTIRE_SUB:
      if (action.entireSub) {
        _formCEntireSubChecked = true;
        _disableFormCMileposts = true;
        _disableFormCLocations = true;
        _disableFormCSubSelection = true;
        _disableFormCAllSubs = true;
        _formCMpTitle = "Uncheck 'SELECT ENTIRE SUB' to enter different MPs";
        _formCLocTitle =
          "Locations values can't be entered for an entire sub restriction";
        _formCSubDropDownTitle =
          "Uncheck 'SELECT ENTIRE SUB' to select multiple subdivisions";
        _form.workStartMp = action.fromMp;
        _form.workStartMpSuffix = action.fromSfx;
        _form.workEndMp = action.toMp;
        _form.workEndMpSuffix = action.toSfx;
        _form.fromLocation = "";
        _form.toLocation = "";
        _showFormCFromLocations = false; //Close the location drop downs if the entire sub is selected
        _showFormCToLocations = false;
      } else {
        _formCEntireSubChecked = false;
        _disableFormCMileposts = false;
        _disableFormCLocations = false;
        _disableFormCSubSelection = false;
        //Don't enable ALL subs for a modify
        if (!_modifyingExistingForm) {
          _disableFormCAllSubs = false;
        }
        _formCMpTitle = "";
        _formCLocTitle = "";
        _formCSubDropDownTitle = "";
        _form.workStartMp = "";
        _form.workStartMpSuffix = "";
        _form.workEndMp = "";
        _form.workEndMpSuffix = "";
      }
      //Removing Mile Post from touched fields
      _touchedFields = _.without(_touchedFields, "workStartMp");
      _touchedFields = _.without(_touchedFields, "workEndMp");
      validateForm();
      _isDirty = true;
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.FORM_C_TEXT_CHANGED:
      let FormCText = [];

      //Break up the entered text when the user hits enter or when a line is longer than the max length. chunkText also performs word wrapping
      let wrappedLines = chunkText(
        action.text,
        Constants.MaxValues.MAX_PATTERN_LINE_LENGTH
      ); //chunk the lines into 62 char segments
      FormCText = wrappedLines.split("\n");

      //Only keep the first 120 lines
      if (FormCText.length > Constants.MaxValues.MAX_PATTERN_LINE_COUNT)
        FormCText.splice(Constants.MaxValues.MAX_PATTERN_LINE_COUNT);

      let text = FormCText.map(function (line, i) {
        return { comment: line, lineNumber: i + 1 };
      }); //build into comment objects
      if (!formConversion.areArraysEqual(text, _form.comments)) {
        _isDirty = true;
        _form.comments = text;
      }
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.TCM_TEXT_CHANGED:
      let TCMText = [];

      //Break up the entered text when the user hits enter or when a line is longer than the max length. chunkText also performs word wrapping
      let tcmWrappedLines = chunkText(
        action.text,
        Constants.MaxValues.MAX_TCM_LINE_LENGTH
      ); //chunk the lines into 59 char segments
      TCMText = tcmWrappedLines.split("\n");

      //Only keep the first 120 lines
      if (TCMText.length > Constants.MaxValues.MAX_PATTERN_LINE_COUNT)
        TCMText.splice(Constants.MaxValues.MAX_PATTERN_LINE_COUNT);

      let tcmText = TCMText.map(function (line, i) {
        return { comment: line, lineNumber: i + 1 };
      }); //build into comment objects
      if (!formConversion.areArraysEqual(tcmText, _form.comments)) {
        _isDirty = true;
        _form.comments = tcmText;
      }
      _events.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.TOGGLE_HIDE_FORM:
      _hideForm = action.value;
      _events.trigger(CHANGE_EVENT);
      break;


    default:
    // no-op
  }
});

function chunkString(str, length) {
  return str.match(new RegExp(".{1," + length + "}", "g"));
}

//Using regular expression to add word wrapping to the string
//Taken in part from https://stackoverflow.com/questions/14484787/wrap-text-in-javascript
function chunkText(str, length) {
  return str.replace(
    new RegExp(`(?![^\\n]{1,${length}}$)([^\\n]{1,${length}})\\s`, "g"),
    "$1\n"
  );
}

function calcDisplayErrors() {
  if (_showAllErrors) {
    var displayErrors = _validity.errors;
    var displayWarnings = _validity.warnings;
  } else {
    var displayErrors = _.filter(_validity.errors, function (er) {
      return _.contains(_touchedFields, er.field);
    });

    var displayWarnings = _.filter(_validity.warnings, function (war) {
      return _.contains(_touchedFields, war.field);
    });
  }
  return _.uniq(_.union(displayErrors, displayWarnings), false, function (er) {
    return er.message;
  });
}

function currentReasonCodes() {
  const selectedRole = userStore.getSelectedRole();
  if (_form.type === Constants.RestrictionTypes.A) {

    // Disable reason codes for Form A and Field users if restriction starts with COMPACTION
    if (
      selectedRole[0] === Constants.Roles.FIELD_USER &&
      _form.reasonDescription &&
      _form.reasonDescription.startsWith("COMPACTION") && _form.syncId)
    {
      _fieldUserCompactionCode = true;
    } else{
        _fieldUserCompactionCode = false;
    }

    //Check if the user's role is set to dispatcher, they are not allowed to select compaction so remove it from the list. If compaction is already selected make the dropdown read only
    if (selectedRole[0] === Constants.Roles.DISPATCHER) {
      if (
        _form.reasonDescription &&
        _form.reasonDescription.startsWith("COMPACTION")
      ) {
        //Make the reason dropdown read only
        _dispatcherCompactionCode = true;
      } else {
        //Remove compaction code from the drop down
        let dispatcherCodes = _.filter(_aReasons, function (code) {
          return !code.text.startsWith("COMPACTION");
        });
        _dispatcherCompactionCode = false;
        return dispatcherCodes;
      }
    } else {
      _dispatcherCompactionCode = false;
    }
    return _aReasons;
  } else if (_form.type === Constants.RestrictionTypes.B) {
    return _bReasons;
  } else return [];
}

function currentRejectReasonCodes() {
  if (_form.type === Constants.RestrictionTypes.A) {
    return _aRejectReasons;
  } else if (_form.type === Constants.RestrictionTypes.B) {
    return _bRejectReasons;
  }
}

function trackCompare(t1, t2) {
  if (t1.name < t2.name) {
    //tr1 is before tr2
    return -1;
  }
  if (t1.name > t2.name) {
    //a is greater than b by the ordering criterion) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

export const restrictionRequestStore = {
  dispatchToken,
  subscribe: _events.on,
  unsubscribe: _events.off,

  //state getters
  isModifying: function () {
    return _modifyingExistingForm;
  },
  isInEditMode: function () {
    return _inEditMode;
  },
  getUnmodifiedRequest: function () {
    return _unmodifiedRequest;
  },
  getForm: function () {
    return _form;
  },
  getActiveForm: function () {
    return _activeForm;
  },
  getFormB: function () {
    return _form;
  },
  isSubmitting: function () {
    return _submitting;
  },
  canSubmit: function () {
    return _canSubmit;
  },
  formValid: function () {
    validateForm();
    return _canSubmit;
  },
  restrictionFormattedForSubmission: function () {
    return formConversion.getServerFormat(_form);
  },
  isDirty: function () {
    return _isDirty;
  },
  getErrors: function () {
    return _validity.errors;
  },
  getTouchedFields: function () {
    return _touchedFields;
  },
  getDisplayErrors: function () {
    return calcDisplayErrors();
  },
  getReasonCodes: function () {
    return currentReasonCodes();
  },
  getRejectReasonCodes: function () {
    return currentRejectReasonCodes();
  },
  getReadOnly: function () {
    return _readOnly;
  },
  getPartialReadOnly: function () {
    return _partialReadOnly;
  },
  getHideActionButtons: () => _hideActionButtons,
  getIsWeatherRequest: () => _isWeatherRequest,
  getSubData: function () {
    return _SubData;
  },
  getTransferredDsId: function () {
    return _form.transferredDsId;
  },
  getShowDefaultTracks: function () {
    return _showDefaultTracks;
  },
  getDefaultTracks: function () {
    return _defaultTrackNames;
  },

  getTrackData: function () {
    return formbScrubber.orderTracks(getAvailableTracks());
  },
  getControlNumber: function () {
    return _form.controlNumber;
  },
  getFormType: function () {
    return _form.type;
  },
  getTextOfRestriction: function () {
    return {
      bmp: parseFloat(_form.workStartMp),
      emp: parseFloat(_form.workEndMp),
      bmpSfx: _form.workStartMpSuffix,
      empSfx: _form.workEndMpSuffix,
      trackNames: _form.tracks.map(function (t) {
        return t.name;
      }),
    };
  },
  getDispatchers: function () {
    return _form.dispatchers;
  },
  getSelectedTracks: function () {
    return _form.tracks.map(function (t) {
      return t.name;
    });
  },
  bothMps: function () {
    return _form.workStartMp && _form.workEndMp;
  },
  isSchematicLoaded: function () {
    return _schematicLoaded;
  },
  areSubLocationsLoading: function () {
    return _subLocationsLoading;
  },
  getSubLocations: function () {
    return _filteredSubLocations;
  },
  getShowFormCFromLocations: function () {
    return _showFormCFromLocations;
  },
  getShowFormTCMFromLocations: function () {
    return _showFormTCMFromLocations;
  },
  getFormCSubdivisions: function () {
    return _formCSubs;
  },
  getFromLocationSuggestion: function () {
    return _fromLocationSuggestion;
  },
  getShowFormCToLocations: function () {
    return _showFormCToLocations;
  },
  getShowFormTCMToLocations: function () {
    return _showFormTCMToLocations;
  },
  getToLocationSuggestion: function () {
    return _toLocationSuggestion;
  },
  getShowSubDropDown: function () {
    return _showSubDrownDown;
  },
  getDisableFormCMps: function () {
    return _disableFormCMileposts;
  },
  getDisableFormCLocations: function () {
    return _disableFormCLocations;
  },
  getDisableFormCSubSelection: function () {
    return _disableFormCSubSelection;
  },
  getDisableFormCEntireSub: function () {
    return _disableFormCEntireSub;
  },
  getDisableFormCAllSubs: function () {
    return _disableFormCAllSubs;
  },
  getFormCMpTitle: function () {
    return _formCMpTitle;
  },
  getFormCLocTitle: function () {
    return _formCLocTitle;
  },
  getFormCSubDropDownTitle: function () {
    return _formCSubDropDownTitle;
  },
  getFormCEntireSubTitle: function () {
    return _formCEntireSubTitle;
  },
  getFormCEntireSubChecked: function () {
    return _formCEntireSubChecked;
  },
  getFormPatterns: function () {
    return _formPatterns;
  },
  getValidatingMPs: function () {
    return _validatingMP;
  },
  getDispatcherCompactionCode: function () {
    return _dispatcherCompactionCode;
  },
   getFieldUserCompactionCode: function () {
     return _fieldUserCompactionCode;
   },
  getHideForm: function () {
    return _hideForm;
  },
};
